import { matchPath, useNavigate } from 'react-router';
import { useLocation } from 'react-router-dom';
import { Tabs } from '@bigcommerce/big-design';

export default function TabbedNavigation({ routes = [] }) {
	const navigate = useNavigate();
	const location = useLocation();

	return (
		<Tabs
			activeTab={
				routes.find(
					({ pathname }) =>
						matchPath(
							{ path: pathname, end: false },
							location.pathname,
						) !== null,
				)?.pathname
			}
			items={routes.map(({ pathname, title }) => ({
				id: pathname,
				title,
			}))}
			onTabClick={navigate}
		/>
	);
}
